import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import {
  deployCacheProvince,
  getCacheProvince,
} from "src/apis/ADB/province.api";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "src/components/notify/Notify";
import Controls from "src/components/form/controls/Controls";
import { currentUserHandleCache } from "src/utils/helper";
import useCurrentUserCache from "src/hooks/useCurrentUserCache";
import useAuth from "src/hooks/useAuth";
import { clearCacheADB } from "src/apis/ADB/adb.api";
import { allowedDeployCache } from "src/constants/role";

const CacheActionDisplay = ({
  action,
  listDataCache,
  localUser,
  currentUserCache,
}) => {
  const colors = {
    Create: "#0069A9",
    Update: "#d68102",
    Delete: "#fb0b12",
  };

  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa ${action.toLowerCase()} ${listDataCache.length} Tỉnh/Thành`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: colors[action] }}
        >
          {`${index + 1}. ${data.provinceName}`}
        </p>
      ))}
    </div>
  );
};

const ShowCacheProvince = ({ disableButton, setDisableButton }) => {
  const [cacheData, setCacheData] = useState({
    listDataCache: [],
    modelCache: null,
    actionCache: null,
  });
  const { currentUserCache } = useCurrentUserCache();
  const { auth } = useAuth();

  useEffect(() => {
    getCacheProvince((result) => {
      setCacheData({
        listDataCache: result.data,
        modelCache: result.model,
        actionCache: result.action,
      });
    });
  }, []);

  const handleAction = (action, apiCall, message) => {
    const notify = action === "deploy" ? NotifyDeployCache : NotifyClearCache;
    notify(
      "warning",
      `${action.charAt(0).toUpperCase() + action.slice(1)} Data ?`,
      `<h5> ${message} </h5>`,
      (result) => {
        if (result.isConfirmed) {
          setDisableButton(true);
          apiCall(() => {
            setDisableButton(false);
            window.location.reload(true);
          });
        }
      }
    );
  };

  const { listDataCache, actionCache } = cacheData;

  return (
    <>
      {actionCache && (
        <CacheActionDisplay
          action={actionCache}
          listDataCache={listDataCache}
          localUser={auth}
          currentUserCache={currentUserCache}
        />
      )}
      <Divider sx={{ width: "100%" }} />

      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {disableButton && (
            <h3
              style={{
                marginTop: "10px",
                paddingTop: "10px",
                marginRight: "20px",
                color: "red",
              }}
            >
              Deploying data
            </h3>
          )}
          <Controls.Button
            sx={{ width: "170px", marginTop: "10px" }}
            color="secondary"
            isLoading={disableButton}
            disabled={disableButton}
            type="button"
            text="Clear Cache"
            onClick={() =>
              handleAction(
                "clear",
                clearCacheADB,
                "Tất cả dữ liệu mới sẽ được hủy bỏ"
              )
            }
          />
          <Controls.Button
            sx={{ width: "170px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            isLoading={disableButton}
            disabled={disableButton}
            text="Deploy Data"
            onClick={() =>
              handleAction(
                "deploy",
                deployCacheProvince,
                "Tất cả dữ liệu mới sẽ được lưu"
              )
            }
          />
        </div>
      )}
    </>
  );
};

export default ShowCacheProvince;
